import { ChipSt } from './Chip.css';
import { ChipProps } from './Chip.types';

export default function Chip({
  label,
  icon,
  colorText,
  colorIcon,
  colorBackground,
  ...props
}: ChipProps) {
  return (
    <ChipSt
      label={label}
      icon={icon}
      colorText={colorText}
      colorIcon={colorIcon}
      colorBackground={colorBackground}
      {...props}
    />
  );
}
